import { Expose, Type } from 'class-transformer';
import { Fleet } from './fleet.model';
import { TruckType } from './truck-type.model';
import { DropdownModel } from '@shared/models/dropdown-model.model';

export class Trailer extends DropdownModel {
  @Expose() id: number;
  @Type(() => TruckType)
  @Expose()
  truckType: TruckType = new TruckType();
  @Type(() => Fleet)
  @Expose()
  fleet: Fleet = new Fleet();
  @Expose() doorNumber: string;

  constructor() {
    super();
  }

  get dropDownDisplayName(): string {
    return this.doorNumber;
  }

  get dropDownValue(): Trailer {
    return this;
  }
}
